import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const SlidersEdit = () => {
  const [slideImage, setSlideImage] = useState(null);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const { id } = useParams();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/slides/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        const data = response.data?.data;
        if (data) {
          setSlideImage(data.slideImage);
        }
      })
      .catch((error) => {
        console.error("Error fetching slider data:", error);
      });
  }, [API_BASE_URL, id]);

  const handleAddNewSliders = () => {
    navigate("/add-sliders");
  };

  const handleViewAllSliders = () => {
    navigate("/all-sliders");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    if (slideImage) {
      formData.append("slideImage", slideImage);
    }

    axios
      .put(`${API_BASE_URL}/admin/slides/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(() => {
        alert("Slider updated successfully.");
        navigate("/all-sliders");
      })
      .catch((error) => {
        console.error("Error updating slider:", error);
        alert("Failed to update the slider. Please try again.");
      });
  };

  return (
    <>
      <div id="add-subject-inner-wrapper">
        <div className="superheader">
          <div className="subjectHeaderdiv">
            <h5>Update Slider</h5>
            <div className="subjectdiv2">
              <button
                className="handleNewSubject"
                onClick={handleAddNewSliders}
              >
                + Add New Slider
              </button>
              <button className="allSubjects" onClick={handleViewAllSliders}>
                All Sliders
              </button>
            </div>
          </div>

          <div className="form-sub-container mt-4" id="form">
            <h4 className="subject-detail">Update Slider Details</h4>
            <form
              className="subject-detail-form"
              encType="multipart/form-data"
              onSubmit={handleSubmit}
            >
              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Upload Slider</label>
                </div>
                <input
                  type="file"
                  id="subject-upload-icon"
                  multiple={false}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setSlideImage(file);
                    }
                  }}
                />
                {slideImage && typeof slideImage === "string" && (
                  <img
                    src={`${API_BASE_URL}/uploads/${slideImage}`}
                    alt="Current Slider"
                    className="w-25 mt-2"
                  />
                )}
              </div>

              <div className="school-subj-form-btns">
                <button className="btn-search" type="submit">
                  Update
                </button>
                <button
                  className="btn-cancel"
                  type="button"
                  onClick={() => navigate("/all-sliders")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default SlidersEdit;
